import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { CustomSelectDropdown } from "./custom.select";
import phone_types from "../../../shared/fixtures/phone_types";
import { selectStyle } from "../../../shared/fixtures/select_style";
import { P } from "../Texts";

export const PhoneType = (props) => {
  const formCtx = useFormContext();
  const {
    formState: { errors: formStateErrors },
  } = formCtx;
  return (
    <>
      <label htmlFor="opCategory">
        <P fontSize="14px" fontFamily="semi" color="#47495C" className="mb-2">
          Phone Type
          <span
            className=""
            style={{
              color: "#E62250",
            }}
          >
            *
          </span>
        </P>
      </label>
      <Controller
        control={props.control}
        {...props}
        defaultValue=""
        rules={{
          required: true,
        }}
        render={({ field }) => (
          <CustomSelectDropdown
            autoComplete="true"
            styles={selectStyle}
            {...field}
            className="w-full"
            placeholder="--Select a type--"
            options={phone_types}
          />
        )}
      />

      {formStateErrors[props.name] && (
        <P fontSize="12px" className="mt-2 mb-4 text-red-400 text-sm">
          Select at a phone type
        </P>
      )}
    </>
  );
};
